import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#2d74ac', colorInfo: '#2d74ac', colorSuccess: '#2d8c7f', colorWarning: '#c97a20',
          colorError: '#b7414e', colorText: '#142840', colorTextPlaceholder: '#7890a4', colorBorder: '#b9cad9', colorBgContainer: '#ffffff', colorBgElevated: '#ffffff', controlOutline: 'rgba(45, 116, 172, .16)', borderRadius: 12, fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        },
        components: { Layout: { siderBg: '#17375e', bodyBg: '#f3f7fb' }, Menu: { darkItemBg: '#17375e', darkSubMenuItemBg: '#17375e', darkItemSelectedBg: '#2b5e91' } },
      }}
    >
      <BrowserRouter><App /></BrowserRouter>
    </ConfigProvider>
  </StrictMode>,
);
